<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >add broker txn</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field v-model="txn_date" id="txn_date" :rules="[required]" label="txn date" variant="underlined" class="form_field" type="date"></v-text-field>
              <v-text-field v-model="ticker" id="ticker" :rules="[required]" label="ticker" variant="underlined" class="form_field"></v-text-field>
              <v-select v-model="txn_type" id="txn_type" :rules="[required]" :items="txnTypeOptions" label="txn type" variant="underlined" class="form_field"></v-select>
              <v-alert v-if="txn_type === 'capital_return_adj'" type="info" density="compact" variant="tonal" class="mb-2">enter cash received as negative value</v-alert>
              <v-alert v-if="txn_type === 'tax_adj'" type="info" density="compact" variant="tonal" class="mb-2">+ve value increases cost base</v-alert>
              <template v-if="!isAdjustment">
                <v-text-field v-model="qty" id="qty" :rules="[required, numeric]" label="qty" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
              </template>
              <v-text-field v-model="currency" id="currency" :rules="currencyRules" label="currency" variant="underlined" class="form_field"></v-text-field>
              <v-text-field v-if="isForeignCurrency" v-model="spot_fx" id="spot_fx" :rules="[required, numeric]" label="spot fx" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
              <template v-if="!isAdjustment">
                <v-text-field v-model="price" id="price" :rules="[required, numeric]" label="price" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
                <v-text-field v-model="brokerage" id="brokerage" :rules="[required, numeric]" label="brokerage" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
                <v-text-field v-model="external_txn_id" id="external_txn_id" label="external id" variant="underlined" class="form_field"></v-text-field>
              </template>
              <template v-if="isAdjustment">
                <v-btn-toggle v-model="input_mode" mandatory class="mb-4">
                  <v-btn value="per_unit" size="small">per unit</v-btn>
                  <v-btn value="total" size="small">total</v-btn>
                </v-btn-toggle>
                <v-text-field v-model="adjustment_amount" id="adjustment_amount" :rules="[required, numeric]" :label="input_mode === 'per_unit' ? 'per unit amount' : 'total amount'" variant="underlined" class="form_field" inputmode="decimal"></v-text-field>
              </template>
              <v-text-field v-model="description" id="description" label="description" variant="underlined" class="form_field"></v-text-field>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    brokerAccountId: Number
  },
  data() {
    return {
      broker_account: '',
      txn_date: '',
      ticker: '',
      txn_type: '',
      qty: '',
      currency: '',
      price: '',
      brokerage: '',
      spot_fx: '',
      external_txn_id: '',
      description: '',
      input_mode: 'per_unit',
      adjustment_amount: '',
      currencyRules: [
        value => {
          if (value) return true

          return 'required.'
        },
        value => {
          if (value == "AUD" || value == "USD" || value == "SGD" || value == "GBP" || value == "SEK" || value == "CAD" ) return true

          return 'unknown currency'
        },
      ],
      txnTypeOptions: [
        { title: 'buy', value: 'buy' },
        { title: 'sell', value: 'sell' },
        { title: 'demerger', value: 'demerger' },
        { title: 'split', value: 'split' },
        { title: 'capital return adj', value: 'capital_return_adj' },
        { title: 'tax adj', value: 'tax_adj' },
      ],
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
    isAdjustment() {
      return this.txn_type === 'capital_return_adj' || this.txn_type === 'tax_adj';
    },
    isForeignCurrency() {
      return this.currency == 'USD' || this.currency == 'SGD' || this.currency == 'GBP' || this.currency == 'SEK' || this.currency == 'CAD';
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        const data = {
          broker_account: this.brokerAccountId,
          txn_date: this.txn_date,
          ticker: this.ticker,
          txn_type: this.txn_type,
          currency: this.currency,
          description: this.description || null
        };

        if (this.isAdjustment) {
          data.input_mode = this.input_mode;
          if (this.input_mode === 'per_unit') {
            data.per_unit_amount = this.adjustment_amount;
          } else {
            data.total_amount = this.adjustment_amount;
          }
          if (this.isForeignCurrency) {
            data.base_currency_spot_rate = this.spot_fx;
          }
        } else {
          data.qty = this.qty;
          data.price = this.price;
          data.brokerage = this.brokerage;
          data.base_currency_spot_rate = this.spot_fx;
          data.external_txn_id = this.external_txn_id;
        }

        await axios.request({
          url: "/securities/txns",
          method: "POST",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data
        });
          this.resetDataValues(); // clear form inputs
          this.$parent.getBrokerTxns(); // update txn list on local
          this.$parent.getOpenPositionData(); // update open position data on local
          this.$emit("close"); // close modal via parent
      } catch (error) {
        const message = error.response?.data?.error || 'Failed to create broker transaction';
        this.showSnackbar({ message });
      }
    },
    resetDataValues(){
      this.txn_date = "";
      this.ticker = "";
      this.txn_type = "";
      this.qty = "";
      this.price = "";
      this.brokerage = "";
      this.currency = "";
      this.spot_fx = "";
      this.external_txn_id = "";
      this.description = "";
      this.input_mode = "per_unit";
      this.adjustment_amount = "";
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    numeric (v) {
        return !isNaN(v) || 'must be a number'
    },
  }
}
</script>

<style scoped>
.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}


</style>
